export const findFocusableElements = (element?: HTMLElement | null) =>
	Array.from(
		element
			? element.querySelectorAll(
					'audio, button, canvas, details, iframe, input, select, summary, textarea, video, [accesskey], [contenteditable], [href], [tabindex]'
			  )
			: []
	) as HTMLElement[];
